import { useTranslation } from "react-i18next";
import { List } from "lucide-react";
import { Button } from "../../components/ui/button/index.js";
import { cn } from "../../lib/utils.js";

export const campaignAudienceActionBaseClass = cn(
  "h-8 gap-1.5 rounded-lg px-3 text-[0.8125rem] transition-[background-color,border-color,color,box-shadow,transform]",
  "focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--color-ring)]",
  "not-disabled:active:translate-y-px motion-reduce:not-disabled:active:translate-y-0",
);

/** Primary navy treatment shared by the Audience card actions (pair with `variant="default"`). */
export const campaignAudiencePrimaryActionClass = cn(
  campaignAudienceActionBaseClass,
  "shadow-[0_1px_2px_rgba(15,23,42,0.18),inset_0_1px_0_rgba(255,255,255,0.08)] not-disabled:hover:shadow-[0_4px_12px_-4px_rgba(15,23,42,0.45)] not-disabled:active:shadow-[0_1px_2px_rgba(15,23,42,0.2)]",
);

export function CampaignManageRecipientsButton({
  onClick,
  variant = "default",
  testId,
}: {
  onClick: () => void;
  variant?: "default" | "outline";
  testId?: string;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      size="sm"
      variant={variant}
      onClick={onClick}
      data-testid={testId}
      className={
        variant === "default" ? campaignAudiencePrimaryActionClass : campaignAudienceActionBaseClass
      }
    >
      <List size={14} aria-hidden="true" />
      {t("campaigns.actions.manageRecipients")}
    </Button>
  );
}
